// extracted by mini-css-extract-plugin
export default {"BaseCell":"date-renderer-module__BaseCell--DnoCJ"};